import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=0ff05a43"
import script from "./StatusChip.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusChip.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports